const e = "_loaderContainer_1kk6d_1", o = {
  loaderContainer: e
};
export {
  o as default,
  e as loaderContainer
};
